var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.params.data.slOrdCnt == 0 || _vm.params.data.ordType == 'SL')?_c('span',[_vm._v("--")]):_vm._e(),(_vm.params.data.slOrdCnt > 0)?_c('button',{staticClass:"btn-link",on:{"click":function($event){return _vm.showModal('modalTPSL', _vm.params.data)}}},[_vm._v("보기")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }